import { render, staticRenderFns } from "./CampusDetail.vue?vue&type=template&id=0c2618a8"
import script from "../../controllers/campus/campus-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/campus/campus-detail.js?vue&type=script&lang=js&external"
import style0 from "./CampusDetail.vue?vue&type=style&index=0&id=0c2618a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports